import { render, staticRenderFns } from "./ClientPassportAdd.vue?vue&type=template&id=4b82f10e&"
import script from "./ClientPassportAdd.vue?vue&type=script&lang=js&"
export * from "./ClientPassportAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports